/* Info Component in IndexCardsPage */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";

const Info = () => {
  return (
    <div>
        <Row className='my-3'>
            <Col className={`text-center px-3 py-1 ${styles.SubTitle6 }`} md={{span: 8, offset: 2 }}>
            <h5 className={`text-center pb-2 ${styles.Red }`} >INDEX CARDS INFO</h5>  
            <hr className={`mt-2 mb-0`}/>
            <p>Create Index Cards for each Scene's <span className={`${styles.Red}`}>Story</span> and <span className={`${styles.Red}`}>Style</span> details 
            to visualise the story ark. 
           </p>
           <hr className={`mt-2 mb-0`}/>
            </Col>
        </Row>
    </div>
  )
}

export default Info